import { retailInfoArr, sellGoodsTypeArr, orderCooperateList } from '@/utils/newDataMap/sampleOrder';
export const configList = [
	{
		label: '团长',
		key: 'authority_id',
		type: 'component',
		component: () => import('@/components/commanderSelect/index.vue'),
		isShow: true,
		isConcact: true, //是否联动
	},
	{
		label: '分销类型',
		key: 'retail_type',
		type: 'select',
		placeholder: '请选择',
		options: retailInfoArr,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '带货类型',
		key: 'sell_goods_type',
		type: 'select',
		placeholder: '请选择',
		options: sellGoodsTypeArr,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '样品协作状态',
		key: 'order_cooperate_status',
		type: 'select',
		placeholder: '请选择',
		options: orderCooperateList,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: true,
	},
];
